export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const UPDATE_EMAIL_OPTED = "UPDATE_EMAIL_OPTED";
export const GET_ACCOUNT_STATUS = "GET_ACCOUNT_STATUS";
export const FETCH_USER_DATA = "FETCH_USER_DATA";
